import $ from 'jquery';

const toggleSideMenu = (el) => {
    const $el = $(el);
    const $content = $el.find('.js-sidemenu-content');
    const $buttons = $el.find('.js-sidemenu-toggle');

    $buttons.click(function (e) {
        e.preventDefault();

        $buttons.toggleClass('js-state-sidemenu--open');
        $content.slideToggle();
    });
};

export default toggleSideMenu;
